import { router } from 'expo-router';
import {
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CircleAlertIcon,
    Icon,
    MailIcon,
    YStack,
} from 'smoothie';

import { SUPPORT_EMAIL } from '../../../settings/types/constants';

export const ReturningMemberCheckEmailMessage = () => (
    <YStack alignItems="center" gap={8} paddingVertical={8}>
        <Icon icon={MailIcon} size={32} color="$black" />
        <BodySmallRegular textAlign="center" color="$gray1000">
            Please check your email to continue setting up your Fruitful
            account.
        </BodySmallRegular>
    </YStack>
);

export const ActiveAccountSignInMessage = () => (
    <YStack alignItems="center" gap={16} paddingVertical={8}>
        <BodySmallRegular textAlign="center" color="$gray1000">
            It looks like you may already have an account with us.
        </BodySmallRegular>
        <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.LARGE}
            text="Sign in"
            onPress={() => {
                router.push('/sign-in');
            }}
        />
    </YStack>
);

export const ReturningMemberErrorMessage = () => (
    <YStack alignItems="center" gap={8} paddingVertical={8}>
        <Icon icon={CircleAlertIcon} size={32} color="$black" />
        <BodySmallRegular textAlign="center" color="$gray1000">
            Something went wrong. Please contact {SUPPORT_EMAIL} for help
            setting up your account.
        </BodySmallRegular>
    </YStack>
);
